import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {withTheme} from "../../../../themes";
import ToggleFilters from './ToggleFilters'
import {Wrapper, Toggle, SearchField} from "./styled";
import { useSelector } from "react-redux";
import { getLayout } from "./../../../../store/settings/selectors";


import CompactMenuIcon from './../../../../components/App/CompactMenuIcon';
import {LAYOUT_XS, LAYOUT_SM} from './../../../../settings';

export const SearchWrapper = styled.div`

  height: 46px;
  display: block;
  position: relative;
  border-radius: ${props => props.borderRadius.value + props.borderRadius.unit};
  overflow: hidden;
  flex-grow: 1;
  flex-shrink: 1;
  background-color: ${props => props.background};
  border-top: ${props => props.borderSize.top}px solid ${props => props.borderColor};
  border-left: ${props => props.borderSize.left}px solid ${props => props.borderColor};
  border-bottom: ${props => props.borderSize.bottom}px solid ${props => props.borderColor};
  border-right: ${props => props.borderSize.right}px solid ${props => props.borderColor};
`;
export const CompactMenuIconWrapper = styled.div`
  margin-top: -2px;
  width: 46px;
  height: 46px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: 7px;
  z-index: 9999;
`;

const Search = ({mobile = false, theme, state, placeholder, onChange, value, isFilterActive, onToggleFilters, filters, hideToggleFilters = false}) => {

  const { search } = theme.list;
  const layout = useSelector(getLayout);

  return (
    <Wrapper mobile={mobile}>
      <SearchWrapper 
        background={theme.list.search.background} 
        borderRadius={theme.list.search.borderRadius}
        borderSize={theme.list.search.borderSize}
        borderColor={theme.list.search.borderColor}
      >
        <SearchField
          onChange={onChange}
          placeholder={placeholder}
          textColor={theme.list.search.textColor}
          placeholderColor={theme.list.search.placeholderColor}
        />
      </SearchWrapper>
      {!hideToggleFilters ? (
        <Toggle layout={layout}>
          <ToggleFilters
            onClick={onToggleFilters}
            iconBackground={!isFilterActive ? search.icon.normal.background: search.icon.active.background}
            iconColor={!isFilterActive ? search.icon.normal.color : search.icon.active.color}
            icon={theme.icons.set.openFilters}
            showSticker={isFilterActive}
            borderRadius={theme.list.search.borderRadius}
          />
        </Toggle>
      ) : null}
      {layout === LAYOUT_XS || layout === LAYOUT_SM ?
        <CompactMenuIconWrapper>
          <CompactMenuIcon />
        </CompactMenuIconWrapper>
      : null }
    </Wrapper>
  );
};

Search.propTypes = {
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isFilterActive: PropTypes.bool
};

export default React.memo(withTheme(Search));
